// extracted by mini-css-extract-plugin
export default {"title":"MetricsChartSection_title__22paO"};